<template>
  <div v-if="ticketAttachments.length > 0" class="file-downloader-container">
    <div class="title">{{ intl[$store.state.lang]["title"] }}</div>
    <div class="files-container">
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="panelsStayOpen-headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseOne"
              aria-expanded="true"
              aria-controls="panelsStayOpen-collapseOne"
            >
              {{ intl[$store.state.lang]["accordion-title"]}}
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="panelsStayOpen-headingOne"
          >
            <div class="attachment"  v-for="(attachment, index) in ticketAttachments" :key="attachment.id">
                
                <div :onclick="() => {downloadAttachment(attachment)}">{{  intl[$store.state.lang]["attachment"] + "("+index+")" }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";

export default {
  name: "ticketAttachmentFileDownloader",
  mounted() {},
  components: {},
  props: {
    ticketId: {
      type: Number,
      default: null,
    },
    setPaginaLoaderCallback: {
            type: Function,
            default: (value) => {console.log("FILE DOWNLOADER LOADER: ",value)},
      },
  },
  created() {
    if (this.ticketId) {
        this.loader = true
      axios
        .get(apiUrls["ticket_detail"] + this.ticketId)
        .then((response) => {
          if (response && response.data && response.data.ticket_attachments) {
            this.ticketAttachments = response.data.ticket_attachments;
          }
          this.loader = false
        })
        .catch((error) => {

            this.loader = false
        });
    }
  },

  data: function () {
    return {
        apiUrls: apiUrls,
        intl: intl,
        ticketAttachments: [],
        loader: false
    };
  },
  methods: {
    downloadAttachment(attachment) {
        if(attachment.id && attachment.path){
            this.loader = true
            axios
        .get(apiUrls["download_ticket_attachment_file"] + attachment.id, {responseType: 'blob'})
            .then((response) => {
                let blob = new Blob([response.data],{ type: response.data.type })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = attachment.path.split('/')[1]
                link.click()
                this.loader = false
            })
            .catch((error) => {
                this.loader = false
            }); 
        }
        
    },
  },
  watch: {
      loader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({ticketAttachmentFileDownloaderLoader: newValue})
                    }                
                },
                immediate: true, 
        },
  },
  computed: {},
};
</script>
